export enum AISurveyType {
  AdvertisingResearch = 1,
  CustomerResearch = 2,
  CustomerSatisfaction = 3,
  BrandNps = 4,
  ProductTesting = 5,
  CustomerExperience = 6
}
